import { render, staticRenderFns } from "./evaluation.vue?vue&type=template&id=63da8070&scoped=true"
import script from "./evaluation.vue?vue&type=script&lang=js"
export * from "./evaluation.vue?vue&type=script&lang=js"
import style0 from "./evaluation.vue?vue&type=style&index=0&id=63da8070&prod&lang=css"
import style1 from "./evaluation.vue?vue&type=style&index=1&id=63da8070&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da8070",
  null
  
)

export default component.exports